// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HGicF1O9whZVZY {
  margin-top: var(--ds-space-100, 8px);
  border-top: var(--ds-border-width, 1px) solid var(--ds-border, #091e4224);
}

.HGicF1O9whZVZY fieldset {
  margin-top: var(--ds-space-100, 8px);
  border: none;
  flex-direction: column;
  display: flex;
}

.HGicF1O9whZVZY .AkHkRMHe3XYvv1 {
  display: flex;
}

.HGicF1O9whZVZY .AkHkRMHe3XYvv1 .KYktDvz0besPs4 {
  margin-bottom: var(--ds-space-150, 12px);
  align-items: center;
  gap: var(--ds-space-100, 8px);
  display: flex;
}

.HGicF1O9whZVZY .AkHkRMHe3XYvv1 ._ZC8bP5Wrx391R {
  padding: var(--ds-space-050, 4px);
  background-color: var(--ds-background-neutral, #091e420f);
  color: var(--ds-text, #172b4d);
  align-items: center;
  display: flex;
}

.HGicF1O9whZVZY .AkHkRMHe3XYvv1 ._ZC8bP5Wrx391R input[type="checkbox"] {
  appearance: none;
}

.HGicF1O9whZVZY .AkHkRMHe3XYvv1 ._ZC8bP5Wrx391R span {
  margin-right: var(--ds-space-050, 4px);
}

.HGicF1O9whZVZY .AkHkRMHe3XYvv1 ._ZC8bP5Wrx391R:hover, .HGicF1O9whZVZY .AkHkRMHe3XYvv1 ._ZC8bP5Wrx391R:focus {
  cursor: pointer;
}

.HGicF1O9whZVZY .VUCSNOkDpWlXoP {
  max-width: max-content;
  margin-top: var(--ds-space-100, 8px);
}

.HGicF1O9whZVZY.SU5iAqkLT6L07_ fieldset {
  padding: unset;
}

.HGicF1O9whZVZY.SU5iAqkLT6L07_ .AkHkRMHe3XYvv1 {
  flex-direction: column;
}

.HGicF1O9whZVZY.SU5iAqkLT6L07_ .AkHkRMHe3XYvv1 .KYktDvz0besPs4 {
  flex-direction: column;
  align-items: flex-start;
  display: flex;
}

.HGicF1O9whZVZY.SU5iAqkLT6L07_ .VUCSNOkDpWlXoP {
  margin-top: var(--ds-space-0, 0);
  align-self: flex-start;
}
`, ""]);
// Exports
export var feedbackDetailContainer = `HGicF1O9whZVZY`;
export var contentContainer = `AkHkRMHe3XYvv1`;
export var reasonsContainer = `KYktDvz0besPs4`;
export var reason = `_ZC8bP5Wrx391R`;
export var submitButton = `VUCSNOkDpWlXoP`;
export var flagTreatment = `SU5iAqkLT6L07_`;
export default ___CSS_LOADER_EXPORT___;
